import { getCookie as getCookieHelper } from '@app/utils/cookieHelpers';

export function cookieConsentFactory(getCookie: typeof getCookieHelper): Consent {
    return {
        isAnalyticsEnabled(): boolean {
            return getGroup(getCookie, 'C0002');
        },
        isAdvertisingEnabled(): boolean {
            return getGroup(getCookie, 'C0003');
        },
        isFunctionalEnabled(): boolean {
            return getGroup(getCookie, 'C0004');
        },
    };
}

export const cookieConsent = cookieConsentFactory(getCookieHelper);

export type Consent = {
    isAnalyticsEnabled: () => boolean;
    isAdvertisingEnabled: () => boolean;
    isFunctionalEnabled: () => boolean;
};

function getGroup(getCookie: typeof getCookieHelper, group:string): boolean {
    let cookieValue = getCookie('OptanonConsent');

    if (!cookieValue) {
        console.error('Error! OptanonConsent cookie is not present. Downstream scripts will not work! Check'
            + ' cookieConsent.ts to see where it is used!');
        return false;
    }

    cookieValue = decodeURIComponent(cookieValue);

    try {
        const groupValue = cookieValue
            .split('&')
            .filter((token) => token.startsWith('group'))
            .filter(Boolean)[0]
            .split('=')[1]
            .split(',')
            .filter(Boolean)
            .filter((el) => el.startsWith(group))[0];

        return groupValue.endsWith(':1');
    } catch (e) {
        console.error('Error! OptanonConsent cookie is malformed. Downstream scripts will not work! Check'
            + ' cookieConsent.ts to see where it is used!');
        return false;
    }
}
